/**
 * Created by Dhanya Akhil on 2/02/2017.
 */
import {Injectable} from "@angular/core"
import {Subject} from 'rxjs';
import {PrincipalService} from "./principal.service";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AccountResourceService} from './account-resource.service';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {
  public isLoggedIn:boolean = false;

  public _identity:any;

  public authenticationState = new Subject<any>();
  constructor(private principal: PrincipalService, public router:Router, public account:AccountResourceService) {

  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
     return this.principal.identity(true).then((account) => {
      this.isLoggedIn = this.principal.isAuthenticated();
      if(this.isLoggedIn){
        return true;
      } else {
        // not logged in so redirect to login page with the return url
        this.router.navigate(['login']);
        return false;
      }
    });
  }
}

